import { getImage } from "gatsby-plugin-image";

// Normalize an ACF media field into { alt, image, url }, or null when empty.
// `image` is a Gatsby image object when localFile processing is available,
// `url` is the raw source URL fallback (SVGs, remote-only images, strings).
export const getMediaData = (media) => {
  if (!media) return null;

  if (typeof media === "string") {
    return { alt: "", image: null, url: media };
  }

  const image = media.localFile ? getImage(media.localFile) : null;
  const url =
    media.sourceUrl ||
    media.mediaItemUrl ||
    media.url ||
    media.localFile?.publicURL ||
    null;

  if (!image && !url) return null;

  return { alt: media.altText || "", image, url };
};

// Plain URL for an ACF media field (no Gatsby image processing). Accepts a raw
// string or a media object; returns "" when nothing usable is present.
export const getMediaUrl = (media) => {
  if (!media) return "";
  if (typeof media === "string") return media;

  return media.sourceUrl || media.mediaItemUrl || media.url || "";
};
